export class NavbarHoverOpener {

    constructor() {
        this.makeSubNavOpenOnHover();
        window.addEventListener('resize', this.makeSubNavOpenOnHover);
    }

    makeSubNavOpenOnHover() {

        document.addEventListener("DOMContentLoaded", function() {
            if ( window.matchMedia("(min-width: 992px)").matches ) {

                document.querySelectorAll('.navbar .nav-item.dropdown').forEach(function(navItem) {

                    navItem.addEventListener('mouseenter', function(e) {
                        const openerLink = this.querySelector('a[data-bs-toggle-hover]');
                        openerLink.classList.add('show');
                        openerLink.nextElementSibling.classList.add('show');
                    });

                    navItem.addEventListener('mouseleave', function(e) {
                        const openerLink = this.querySelector('a[data-bs-toggle-hover]');
                        openerLink.classList.remove('show');
                        openerLink.nextElementSibling.classList.remove('show');
                    });

                });

            }
        });
    }
}

export default new NavbarHoverOpener();
